import { POIS_SERVICE } from "@/services/pois.service.js";
import router from '@/router/index';

const state = { listOutput: {}, processTask: false, coordinatesOutput: {} };

const actions = {
    getList({ dispatch, commit }, params) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        
        POIS_SERVICE.list(params)
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    editPoi({ dispatch, commit }, inputPoi) {
        dispatch('alert/clear', null, { root: true });
        commit('editRequest');
        POIS_SERVICE.edit(inputPoi.poi, inputPoi.image)
            .then(
                output => {
                    commit('editSuccess', output);
                },
                error => {
                    commit('editFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    addPoi({ dispatch, commit }, inputPoi) {
        dispatch('alert/clear', null, { root: true });
        commit('addRequest');

        POIS_SERVICE.add(inputPoi.poi, inputPoi.image)
            .then(
                output => {
                    commit('addSuccess', output);
                },
                error => {
                    commit('addFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    updateStatus({ dispatch, commit }, inputStatus) {
        dispatch('alert/clear', null, { root: true });
        commit('updateStatusRequest');

        POIS_SERVICE.updateStatus(inputStatus.id, inputStatus.status)
            .then(
                output => {
                    commit('updateStatusSuccess', output);
                },
                error => {
                    commit('updateStatusFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getCoordinates({ dispatch, commit }, placeId) {
        dispatch('alert/clear', null, { root: true });
        commit('getCoordinatesRequest');
        POIS_SERVICE.getCoordinates(placeId)
            .then(
                output => {
                    commit('getCoordinatesSuccess', output);
                },
                error => {
                    commit('getCoordinatesFailure', error);
                    dispatch('alert/error', error, { root: true });

                }
            );
    },

};

const mutations = {
    /* List */
    listRequest(state) {
        //
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = [];
    },
    /* Add */
    addRequest(state) {
        state.processTask = null;
    },
    addSuccess(state) {
        state.processTask = true;
    },
    addFailure(state) {
        state.processTask = false;

    },
    /* Edit */
    editRequest(state) {
        state.processTask = null;
    },
    editSuccess(state) {
        state.processTask = true;
    },
    editFailure(state) {
        state.processTask = false;
    },
    
    /* Update status */
    updateStatusRequest(state) {
        state.processTask = null;
    },
    updateStatusSuccess(state) {
        state.processTask = true;
    },
    updateStatusFailure(state) {
        state.processTask = false;
    },
    /* Get coordinates */
    getCoordinatesRequest(state) {
        state.coordinatesOutput = null;
    },
    getCoordinatesSuccess(state, output) {
        state.coordinatesOutput = output;
    },
    getCoordinatesFailure(state) {
        state.coordinatesOutput = false;
    },

}; 

export const pois = {
    namespaced: true,
    state,
    actions,
    mutations
};